import { createModel } from '@rematch/core';
import { EncounterRxReconcile } from '../../models/encounter-rx-reconcile';
import { getEncounterRxReconciles } from '../../apis/encounter-rx-reconcile';

export interface State {
    byId: Dictionary<EncounterRxReconcile>; // id: patientRxId
    loading: Dictionary<boolean>;
}

export const encounterRxReconciles = createModel<State>({
    state: {
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: Undefinable<MixType<EncounterRxReconcile>>,
            loadingKey?: string
        ): State => ({
            ...state,
            byId: {
                ...state.byId,
                ...storeByPatientRxId(data)
            },
            ...loadingKey && {
                loading: {
                    ...state.loading,
                    [loadingKey]: false
                }
            }
        }),
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getEncounterRxReconcilesAsync(ids: number[]) {
            if (ids.length > 0) {
                this.loading('getEncounterRxReconcilesAsync', true);
                try {
                    const data = await getEncounterRxReconciles(ids);
                    this.update(data, 'getEncounterRxReconcilesAsync');
                } catch (e) {
                    window.console.log(e);
                    this.loading('getEncounterRxReconcilesAsync', false);
                }
            }
        }
    })
});

export const storeByPatientRxId = (data: Undefinable<MixType<EncounterRxReconcile>>): Dictionary<EncounterRxReconcile> => {
    if (data) {
        if (Array.isArray(data)) {
            return data.reduce(
                (prev, x) => {
                    prev[x.patientRxId] = x;
                    return prev;
                },
                {} as Dictionary<EncounterRxReconcile>
            );
        } else {
            return {
                [data.patientRxId]: data
            } as Dictionary<EncounterRxReconcile>;
        }
    } else {
        return {} as Dictionary<EncounterRxReconcile>;
    }
};
